export const pagination = [10, 20, 50, 100, 200, 500];
export const rowsPerPage = 20;
// the timeline will load 60 days of timeline actions on desktop
export const daysOnDesktop = 60;
// the timeline will load 7 days of timeline actions on mobile
export const daysOnMobile = 7;
// Max allocation limit allowed at a time is 10000
export const maxSelectionWarningCount = 10000;
export const alertMessageOnSelection = `Count of cases should not be more than ${maxSelectionWarningCount}`
// To append LoanId and CustomerId when flag is true
export const prefixKey = 'MNTRFlag';
// default communicationconfig id for phone while calling to a customer
export const phoneCommunicationConfig = 61; // make it 74
export const ZESTMONEY_INSTIUTTE_ID = '3'
export const instituteId = localStorage.getItem('instituteId')
/**
 * Tooltip (Helper) text for RuleEngine's
 * Any flag
 * Include Followup date flag
 */
export const anyOrAndInfo: string = 'Check whether any one of the following last response conditions should meet to run Rule';
export const followUpDateInfo: string = 'Check to include FollowUp Date';
export const profileCustomerResponseId = 4825;
export const alterDisbaleMessage = `Do you want to update the amount paid of the user to Digital User!`